import * as remoteAction from "../remoteAction";

export type GetShopifyActiveDiscountsActionSuccess =
  remoteAction.MerchantRemoteResponse<
    "GET_SHOPIFY_ACTIVE_DISCOUNTS_SUCCESS",
    any
  >;
export type GetShopifyActiveDiscountsActionFailure =
  remoteAction.MerchantRemoteResponse<
    "GET_SHOPIFY_ACTIVE_DISCOUNTS_FAILURE",
    any
  >;
export type GetShopifyActiveDiscountsActionRequest =
  remoteAction.MerchantRemoteResponse<
    "GET_SHOPIFY_ACTIVE_DISCOUNTS_REQUEST",
    any
  >;

export interface GetShopifyActiveDiscountsAction
  extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_SHOPIFY_ACTIVE_DISCOUNTS_REQUEST";
    success: "GET_SHOPIFY_ACTIVE_DISCOUNTS_SUCCESS";
    failure: "GET_SHOPIFY_ACTIVE_DISCOUNTS_FAILURE";
  };
}

export function getShopifyActiveDiscounts(): GetShopifyActiveDiscountsAction {
  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_SHOPIFY_ACTIVE_DISCOUNTS_FAILURE",
      request: "GET_SHOPIFY_ACTIVE_DISCOUNTS_REQUEST",
      success: "GET_SHOPIFY_ACTIVE_DISCOUNTS_SUCCESS",
    },
    https: true,
    url: "/shopify/activeAccountCredit/discount",
  };
}
